import { render, staticRenderFns } from "./courseIndex.vue?vue&type=template&id=6199a36f&scoped=true&"
import script from "./courseIndex.vue?vue&type=script&lang=js&"
export * from "./courseIndex.vue?vue&type=script&lang=js&"
import style0 from "./courseIndex.vue?vue&type=style&index=0&id=6199a36f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6199a36f",
  null
  
)

export default component.exports